<template>
  <div class="container page recharge-page">
    <van-nav-bar :title="$t('recharge.recharge')" class="nav-bar" :border="false">
      <template #left>
        <van-icon name="arrow-left" @click="back()" />
      </template>
      <template #right>
        <van-icon name="service-o" @click="$router.push('/ServiceOnline')" />
      </template>
    </van-nav-bar>

    <div class="main-content">
      <div class="balance-bar">
        <span class="balance-label">{{ $t('my.balance') }}</span>
        <span class="balance-val">${{ balance }}</span>
      </div>

      <div class="form-body">
        <div class="input-row">
          <span class="input-icon">$</span>
          <input
            v-model="money"
            type="number"
            class="amount-input"
            :placeholder="$t('reservation.money')"
          />
        </div>

        <div class="quick-block">
          <div class="quick-title">{{ $t('recharge.quick_select') }}</div>
          <div class="quick-grid">
            <div
              v-for="amount in quickAmounts"
              :key="amount"
              class="quick-item"
              :class="{ active: money == amount }"
              @click="selectAmount(amount)"
            >
              {{ amount }}
            </div>
          </div>
        </div>

        <button class="submit-btn" @click="onSubmit">
          {{ $t('recharge.confirm') }}
        </button>

        <p class="tip-text">{{ $t('recharge.tip') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RechargePage',
  data() {
    return {
      balance: '0.00',
      money: '',
      quickAmounts: [50, 100, 200, 500, 1000, 3000, 5000, 10000, 30000]
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    }
  },
  mounted() {
    if (this.$route.params.balance) {
      this.balance = this.$route.params.balance
    } else {
      this.getUserBalance()
    }
  },
  methods: {
    back() {
      window.history.back()
    },
    selectAmount(amount) {
      this.money = amount
    },
    getUserBalance() {
      this.$http({ method: 'get', url: 'user_info' }).then(res => {
        if (res.code === 200) this.balance = res.data.money || '0.00'
      }).catch(() => {})
    },
    onSubmit() {
      const money = parseFloat(this.money)
      if (!money || money <= 0) {
        this.$toast(this.$t('reservation.money_err'))
        return
      }
      this.$router.push('/ServiceOnline')
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/css/base.css';

.recharge-page {
  background: #fff;
}

.main-content {
  background: #fff;
  padding: 0;
}

.balance-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.75rem;
  padding: 1.125rem 1rem;
  border-radius: 0.625rem;
  color: #fff;
  background: linear-gradient(135deg, #8056e3 0%, #c94d9a 55%, #db498c 100%);

  .balance-label {
    font-size: 0.9375rem;
    opacity: 0.95;
  }

  .balance-val {
    font-size: 1.375rem;
    font-weight: 700;
  }
}

.form-body {
  padding: 0.5rem 0.75rem 1.5rem;
}

.input-row {
  display: flex;
  align-items: center;
  padding: 0.75rem 0.25rem;
  border-bottom: 1px solid #eee;
  margin-bottom: 1.25rem;

  .input-icon {
    flex-shrink: 0;
    width: 1.75rem;
    font-size: 1.375rem;
    font-weight: 600;
    color: #d63f8c;
    margin-right: 0.5rem;
  }

  .amount-input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-size: 1.125rem;
    color: #333;

    &::placeholder {
      color: #bbb;
      font-size: 1rem;
    }
  }
}

.quick-block {
  margin-bottom: 1.75rem;
}

.quick-title {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.75rem;
}

.quick-grid {
  display: flex;
  flex-wrap: wrap;
  margin: -0.3125rem;
}

.quick-item {
  width: calc(33.33% - 0.625rem);
  margin: 0.3125rem;
  height: 2.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e8e8e8;
  border-radius: 0.5rem;
  font-size: 1rem;
  color: #666;
  background: #fff;
  box-sizing: border-box;

  &.active {
    border-color: #d63f8c;
    color: #d63f8c;
    background: rgba(214, 63, 140, 0.06);
    font-weight: 600;
  }
}

.submit-btn {
  display: block;
  width: 100%;
  height: 3rem;
  border: none;
  border-radius: 1.5rem;
  color: #fff;
  font-size: 1.0625rem;
  font-weight: 600;
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
  margin-bottom: 0.875rem;
}

.tip-text {
  margin: 0;
  text-align: center;
  font-size: 0.8125rem;
  color: #999;
  line-height: 1.5;
}
</style>
